import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

  const setActiveTab = (state, { payload }) => {
      state.activeTab=payload
  };

  const clearActiveTab = (state, { payload })  => {
    return {...state, activeTab:0 };
  };
  const setActiveSuiteTab = (state, { payload }) => {
    state.suiteActiveTab=payload
};

const clearActiveSuiteTab = (state, { payload })  => {
  return {...state, suiteActiveTab:0 };
};
const setActiveCommonAreaTab = (state, { payload }) => {
  state.commonAreaActiveTab=payload
};

const clearActiveCommonAreaTab = (state, { payload })  => {
return {...state, commonAreaActiveTab:0 };
};

const setActiveContactTab = (state, { payload }) => {
  state.contactActiveTab=payload
};

const clearActiveContactTab = (state, { payload })  => {
return {...state, contactActiveTab:0 };
};

const setActiveCatalogTab = (state, { payload }) => {
  state.catalogActiveTab=payload
};

const clearActiveCatalogTab = (state, { payload })  => {
return {...state, catalogActiveTab:0 };
};
  const initialState = {
    activeTab:0,
    suiteActiveTab:0,
    commonAreaActiveTab:0,
    contactActiveTab:0,
    catalogActiveTab:0,
  };

  export default createReducer(initialState, {
    [TYPES.SET_ACTIVE_TAB]: setActiveTab,
    [TYPES.CLEAR_ACTIVE_TAB]:clearActiveTab,
    [TYPES.SET_ACTIVE_SUITE_TAB]: setActiveSuiteTab,
    [TYPES.CLEAR_ACTIVE_SUITE_TAB]:clearActiveSuiteTab,
    [TYPES.SET_ACTIVE_COMMONAREA_TAB]: setActiveCommonAreaTab,
    [TYPES.CLEAR_ACTIVE_COMMONAREA_TAB]:clearActiveCommonAreaTab,
    [TYPES.SET_ACTIVE_CONTACT_TAB]: setActiveContactTab,
    [TYPES.CLEAR_ACTIVE_CONTACT_TAB]:clearActiveContactTab,
    [TYPES.SET_ACTIVE_CATALOG_TAB]: setActiveCatalogTab,
    [TYPES.CLEAR_ACTIVE_CATALOG_TAB]:clearActiveCatalogTab
  });
